import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';

export class Footer extends Component {
    render() {
        let myPageLink;
        let myOrgPageLink;

        // links for different types of users
        if (this.props.logInMember) {
            myPageLink = <Link to="/myPage" activeStyle={{ color: "black" }}>My Homepage</Link>
            myOrgPageLink = <Link to="/">My Programs &amp; Events</Link>
        } else if (this.props.logInOrg) {
            myPageLink = <Link to="/">My Homepage</Link>
            myOrgPageLink = <Link to="/myOrgPage" activeStyle={{ color: "black" }}>My Programs &amp; Events</Link>
        } else {
            myPageLink = <Link to="/">My Homepage</Link>
            myOrgPageLink = <Link to="/">My Programs &amp; Events</Link>
        }

        return (
            <footer className="page-footer font-small bg-color-theme-1">
                <div className="p-5">
                    <Container className="text-center text-md-left">
                        <Row>
                            <Col md="3" className="col-md-3 mx-auto">
                                <h2 className="font-weight-bold text-uppercase mt-3 mb-4 font-size-title">FOR ORGANIZATIONS</h2>
                                <ul className="list-unstyled">
                                    <li>
                                        {myOrgPageLink}
                                    </li>
                                    <li>
                                        <Link to='/policyOrgPage' activeStyle={{ color: "black" }}>Terms of Services</Link>
                                    </li>
                                </ul>
                            </Col>
                            <hr className="clearfix w-100 d-md-none" />
                            <Col md="3" className="col-md-3 mx-auto">
                                <h2 className="font-weight-bold text-uppercase mt-3 mb-4 font-size-title">FOR MEMBERS</h2>
                                <ul className="list-unstyled">
                                    <li>
                                        {myPageLink}
                                    </li>
                                    <li>
                                        <Link to="/browse" activeStyle={{ color: "black" }}>Browse Programs &amp; Events</Link>
                                    </li>
                                    <li>
                                        <Link to='/policyPage' activeStyle={{ color: "black" }}>Terms of Services</Link>
                                    </li>
                                </ul>
                            </Col>
                            <hr className="clearfix w-100 d-md-none" />
                            <Col md="3" className="mx-auto">
                                <h2 className="font-weight-bold text-uppercase mt-3 mb-4 font-size-title">ABOUT SPENEEDS</h2>
                                <ul className="list-unstyled">
                                    <li>
                                        <Link to="/aboutUs" activeStyle={{ color: "black" }}>Our Mission</Link>
                                    </li>
                                    <li>
                                        <Link to="/howSpeNeedsWorks" activeStyle={{ color: "black" }}>How SpeNeeds Works</Link>
                                    </li>
                                    <li>
                                        <Link to="/faqs" activeStyle={{ color: "black" }}>FAQs</Link>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="footer-copyright text-center py-3 bg-dark text-color-theme-1 kurb-med">© 2019 Copyright:
                    <Link className="text-color-theme-1" to="/" activeStyle={{ color: "rgba(247, 248, 246, 0.918)" }}> SpeNeeds.com</Link>
                </div>
            </footer>
        );
    }
}